import { NavigateFunction } from 'react-router';
import { ILoginPhase } from './ILoginPhase';

export class UpdateProfilePhase implements ILoginPhase {
    perform(navigate: NavigateFunction) {
        navigate('/logon/update_profile');
    }
}
